import useDataFetcher from '~/components/useDataFetcher';
import type { MoiMethodInfoListMoiMethodInfo } from '~/server_shared/openapi/data-contracts';
import { stringCmp } from '~/Utils';

export interface UseOrganizationMoiMethodsResult {
  methods: MoiMethodInfoListMoiMethodInfo[];
  isLoading: boolean;
  isError: boolean;
}

/** The organization's MOI methods, read from the sysconfig route: the claim-scoped `useMoiMethods`
 *  needs a claim and an exposure, which a sysconfig screen does not have. */
export const useOrganizationMoiMethods = (organizationId: number): UseOrganizationMoiMethodsResult => {
  const { data, isLoading, isError } = useDataFetcher<MoiMethodInfoListMoiMethodInfo[]>(
    `/sysconfig/api/v1/organizations/${organizationId}/moi_methods`
  );

  return {
    // A copy: `data` is the fetcher's own state, which an in-place sort would mutate.
    methods: [...(data ?? [])].sort((a, b) => stringCmp(a.display_name, b.display_name)),
    isLoading,
    isError,
  };
};
